module.exports = __webpack_public_path__ + "img/elibrary.3311db71.svg";